import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-black text-beige py-12">
      <div className="max-w-7xl mx-auto px-6">
        {/* Top Section */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Column 1 - About */}
          <div>
            <h3 className="text-2xl font-bold mb-4">Sharon Daley</h3>
            <p className="text-beige opacity-80 leading-relaxed">
              English Tutor with over 15 years of experience, specializing in Primary, 
              Secondary, A Level, and Degree-level tuition.
            </p>
          </div>

          {/* Column 2 - Quick Links */}
          <div>
            <h4 className="text-xl font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => scrollToSection('about')}
                  className="text-beige opacity-80 hover:opacity-100 transition-opacity"
                >
                  About
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('services')}
                  className="text-beige opacity-80 hover:opacity-100 transition-opacity"
                >
                  Services & Fees
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('testimonials')}
                  className="text-beige opacity-80 hover:opacity-100 transition-opacity"
                >
                  Testimonials
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('contact')}
                  className="text-beige opacity-80 hover:opacity-100 transition-opacity"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Column 3 - Contact Info */}
          <div>
            <h4 className="text-xl font-semibold mb-4">Get in Touch</h4>
            <p className="text-beige opacity-80 mb-2">
              Available for online tuition
            </p>
            <p className="text-beige opacity-80">
              Response within one working day
            </p>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-beige opacity-20 mb-6"></div>

        {/* Bottom Section */}
        <div className="text-center">
          <p className="text-sm text-beige opacity-70">
            © {currentYear} Sharon Daley - English Tutor. All rights reserved.
          </p>
          <p className="text-xs text-beige opacity-50 mt-2">
            DBS Certified | Safeguarding Trained | SEND Specialist
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;